export { default } from 'common/enums/education-function.enum';
